import React from 'react';

const CGUPage = () => {
  return (
    <div className="cgu-page container">
      <h1>Conditions Générales d’Utilisation (CGU)</h1>

      <p><strong>Vie et couleurs</strong> – <a href="https://vie-et-couleurs.nokram.fr" target="_blank" rel="noreferrer">https://vie-et-couleurs.nokram.fr</a></p>

      <h2>1. Objet</h2>
      <p>
        Les présentes Conditions Générales d’Utilisation (ci-après « CGU ») définissent les modalités d’accès et d’utilisation du site internet Vie et couleurs (ci-après « le Site »).
        En accédant au Site, l’utilisateur reconnaît avoir lu, compris et accepté sans réserve les présentes CGU.
      </p>

      <h2>2. Éditeur du Site</h2>
      <p>
        Le Site est édité par :<br />
        Monsieur Yassine SENANE<br />
        Entrepreneur individuel<br />
        Adresse : 4 rue René Dumont, 44220 Couëron – France<br />
        SIRET : 911 203 990 00013<br />
        Téléphone : 07 66 05 98 63<br />
        Email : <a href="mailto:senane.yassine44@gmail.com">senane.yassine44@gmail.com</a>
      </p>

      <h2>3. Accès et utilisation du Site</h2>
      <p>
        Le Site est accessible gratuitement à tout utilisateur disposant d’un accès à Internet. Les frais liés à cet accès (connexion, matériel informatique, etc.) sont à la charge de l’utilisateur.
      </p>
      <p>
        L’utilisateur s’engage à :
      </p>
      <ul>
        <li>utiliser le Site dans le respect des lois et règlements en vigueur,</li>
        <li>ne pas porter atteinte au bon fonctionnement du Site,</li>
        <li>ne pas détourner les informations présentes sur le Site à des fins illicites ou commerciales.</li>
      </ul>

      <h2>4. Services proposés</h2>
      <p>
        Le Site a pour objet de présenter l’activité de nettoyage courant des bâtiments exercée par l’éditeur. Il permet aux utilisateurs de contacter l’entreprise via un formulaire de contact.
      </p>

      <h2>5. Propriété intellectuelle</h2>
      <p>
        L’ensemble des éléments composant le Site (textes, images, logo, structure, design, etc.) est protégé par le droit de la propriété intellectuelle. Toute reproduction, diffusion, modification ou utilisation, totale ou partielle, sans autorisation préalable écrite de l’éditeur est interdite.
      </p>

      <h2>6. Responsabilités</h2>
      <p>
        L’éditeur s’efforce de fournir des informations exactes et à jour. Toutefois, il ne saurait être tenu responsable en cas de :
      </p>
      <ul>
        <li>erreurs, omissions ou inexactitudes dans le contenu du Site,</li>
        <li>indisponibilité temporaire ou définitive du Site,</li>
        <li>dommages directs ou indirects liés à l’utilisation du Site.</li>
      </ul>
      <p>L’utilisateur est seul responsable de l’usage qu’il fait des informations fournies sur le Site.</p>

      <h2>7. Liens hypertextes</h2>
      <p>
        Le Site peut contenir des liens vers d’autres sites internet. L’éditeur n’exerce aucun contrôle sur ces sites tiers et décline toute responsabilité quant à leur contenu ou leur fonctionnement.
      </p>

      <h2>8. Protection des données personnelles</h2>
      <p>
        Les données personnelles collectées via le formulaire de contact (nom, prénom, email, téléphone, contenu du message) sont utilisées uniquement afin de répondre aux demandes des utilisateurs.
        Ces données ne sont pas stockées dans une base et sont supprimées une fois la demande traitée.
      </p>
      <p>
        Pour plus d’informations, l’utilisateur est invité à consulter la <a href="/politique-de-confidentialite">Politique de confidentialité</a> du Site.
      </p>

      <h2>9. Modification des CGU</h2>
      <p>
        L’éditeur se réserve le droit de modifier les présentes CGU à tout moment et sans préavis. La version applicable est celle disponible en ligne au moment de la navigation par l’utilisateur.
      </p>

      <h2>10. Droit applicable et juridiction compétente</h2>
      <p>
        Les présentes CGU sont régies par le droit français. En cas de litige, et à défaut de solution amiable, les tribunaux compétents français seront saisis.
      </p>
    </div>
  );
};

export default CGUPage;


